import React from 'react';
import { ButtonReSendEmailStyle } from './style';
import { useDispatch } from 'react-redux';
import { ResendEmailUserAction } from '../../redux/actions/user';

export default function ButtonReSendEmail({ email }) {
  const dispatch = useDispatch();
  return (
    <ButtonReSendEmailStyle>
      <button onClick={() => dispatch(ResendEmailUserAction(email))}>Re-enviar Email</button>
    </ButtonReSendEmailStyle>
  );
}
